<template>
  <div>
    <dynamic sign="all"></dynamic>
    <div class="paiZhao" @click="releaseContents">
      <img src="../../assets/images/write.png" alt />
      <span>发表动态</span>
    </div>
  </div>
</template>

<script>
import Dynamic from "./Dynamic";
// import InteractionApi from "@/api/interaction";

export default {
  components: {
    Dynamic,
  },
  data() {
    return {
      active: 0,
      allList: [],
      ugcLink: "v2/api/app/ad_other//ugc/select/ugcApp",
      bodyObj: {
        page: 1,
        size: 15,
        title: "",
      },
    };
  },
  created() {},
  mounted() {
    // this.getUserMessage();
  },
  methods: {
    // 发布
    releaseContents() {
      if (!JSON.parse(window.localStorage.userinfo).id) {
        this.login();
      } else {
        this.releaseContent();
        // let link;
        // link = window.location.href.split("#/")[0] + "#/publish";
        // // window.location.href = link;
        // this.linkPhone({ url: link, title: "爆料发布", isToLocation: true });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.c_wra {
  display: flex;
  .c_con {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}
.paiZhao {
  position: fixed;
  width: 25vw;
  height: 8vw;
  bottom: 115px;
  right: 0;
  background: #e22018;
  z-index: 9;
  border-top-left-radius: 123px;
  border-bottom-left-radius: 123px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 0.3rem;
  img {
    width: 6vw;
  }
}
</style>